import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Box, Typography } from "@curves/ui-base";
import PrivacyDataToggle from '@icoach/components/PrivacyDataToggle';
import { MemberAvatar } from '@icoach/components/infoCard/';
import InfoCard from './InfoCard';

export const CustomerSecureBox = ({
    className,
    avatar,
    avatarWidth = '5.5',
    name,
    maskName,
    phone,
    maskPhone,
    sourceType,
    link,
    onClick,
    isShowAvatar = true,
    isRevealed,
    toggle,
    ...rest
}) => {
    return (
        <InfoCard className={clsx('customer-info-card', className)} link={link} onClick={onClick} {...rest}>
            {isShowAvatar && <MemberAvatar className={'member-info-card__avatar'} src={avatar} width={avatarWidth} alt={name} />}
            <Box className={'customer-info-card__content'}>
                <PrivacyDataToggle fullData={name} maskedData={maskName} isRevealed={isRevealed} onToggle={toggle} />
                {sourceType && (
                    <Typography className={'customer-info-card__source-type'} title={phone}>
                        {sourceType}
                    </Typography>
                )}
                {phone ? <PrivacyDataToggle fullData={phone} maskedData={maskPhone} isRevealed={isRevealed} onToggle={toggle} /> : null}
            </Box>
        </InfoCard>
    );
};

CustomerSecureBox.prototype = {
    className: PropTypes.string,
    avatar: PropTypes.string,
    avatarWidth: PropTypes.string,
    name: PropTypes.string.isRequired,
    maskName: PropTypes.string,
    sourceType: PropTypes.string,
    phone: PropTypes.string,
    maskPhone: PropTypes.string,
    link: PropTypes.string,
    onClick: PropTypes.func,
    isShowAvatar: PropTypes.bool,
};

export default CustomerSecureBox;
